import { render, staticRenderFns } from "./ExternalMenu.vue?vue&type=template&id=2ba16b54&scoped=true&"
import script from "./ExternalMenu.vue?vue&type=script&lang=ts&"
export * from "./ExternalMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba16b54",
  null
  
)

export default component.exports